import React from 'react';
import { Tooltip } from '@material-ui/core';
import { InfoOutlined } from '@material-ui/icons';
import { PrimaryButton, TextField } from '../../components/AtomComponents';
import { IVerticalSyncV3FormProps } from './types';

export const VerticalSyncV3Form = ({
  formState,
  actions,
}: IVerticalSyncV3FormProps) => {
  const { values, isTransactionPerTenant } = formState;
  const { environment, setEnvironment, release, setRelease, tenantId, setTenantId } = values;
  const { onReviewClick, onSyncClick } = actions;

  const isReviewQueriesDisabled = !environment.length || !release;
  const isSyncDisabled = !environment.length || !release || (isTransactionPerTenant && !tenantId);

  return (
    <>
      <TextField
        label="Environment"
        size="small"
        value={environment}
        onChange={(e) => setEnvironment(e.target.value.trim())}
        placeholder="Environment"
        className="margin-right-1"
      />
      <TextField
        label="Release"
        size="small"
        value={release}
        onChange={(e) => setRelease(e.target.value.trim())}
        placeholder="Release"
        className="margin-right-1 px-release-input"
      />

      {isTransactionPerTenant && (
        <span className="px-tenant-info-wrapper">
          <TextField
            label="Tenant ID"
            size="small"
            value={tenantId}
            onChange={(e) => setTenantId(e.target.value.trim())}
            placeholder="Tenant ID"
            className="margin-right-1"
          />
          <Tooltip
            title="Review queries displays pending queries across all tenants. Sync can be executed one tenant at a time by specifying the Tenant ID."
            placement="top"
            arrow
            classes={{ popper: 'pxw-tooltip-popper' }}
          >
            <InfoOutlined className="px-tenant-info-icon" />
          </Tooltip>
        </span>
      )}

      <PrimaryButton
        className="margin-right-1"
        disabled={isReviewQueriesDisabled}
        onClick={onReviewClick}
      >
        Review Queries and Approve
      </PrimaryButton>

      {isTransactionPerTenant ? (
        <Tooltip
          title={!tenantId ? 'Enter a Tenant ID to enable sync' : 'Sync schema for specified Tenant ID'}
          placement="top"
          arrow
          classes={{ popper: 'pxw-tooltip-popper' }}
        >
          <span className="px-tooltip-wrapper">
            <PrimaryButton disabled={isSyncDisabled} onClick={onSyncClick}>
              Sync
            </PrimaryButton>
          </span>
        </Tooltip>
      ) : (
        <PrimaryButton disabled={isSyncDisabled} onClick={onSyncClick}>
          Sync
        </PrimaryButton>
      )}
    </>
  );
};
